import React from 'react'

const BlogCopyBlock = () => {
  return (
    <div>
      <div className="prose !m-0 min-w-full rounded-[18px] !bg-primary-50 !p-6">
        <h3 className="mb-2">Our Promise</h3>
        <h3 className="mb-2 text-base">
          How Is{' '}
          <a
            className="text-base"
            href="/"
          >
            Recovery.com
          </a>{' '}
          Different?
        </h3>
        <p className="text-base">
          We believe everyone deserves access to accurate, unbiased information
          about mental health and recovery. That’s why we have a comprehensive
          set of treatment providers and don't charge for inclusion. Any center
          that meets our{' '}
          <a
            className="text-base"
            href="/criteria/"
          >
            criteria
          </a>{' '}
          can list for free. We do not and have never accepted fees for
          referring someone to a particular center. Providers who advertise with
          us must be{' '}
          <a
            className="text-base"
            href="/claim-verify-process/"
          >
            verified by our Research Team
          </a>{' '}
          and we clearly mark their status as advertisers. <br />
          <div className="h-2" />
          Our goal is to help you choose the best path for your recovery. That
          begins with information you can trust.
        </p>
      </div>
    </div>
  )
}

export default BlogCopyBlock
